import { take, call, put, select, all, race } from 'redux-saga/effects'
import { apiSaga } from './sagas'
import { callApi } from '../../api/api'
import { selectCurrentMenu, selectCurrentUser } from './selectors'
import { LOAD_MENU_SUCCESS, LOAD_MENU_FAILURE } from './order'

// ------------------------------------
// Action Types & Creators
// ------------------------------------

export const ADD_FAVORITE = 'foodsby/favorite/ADD_FAVORITE'
export const ADD_FAVORITE_SUCCESS = 'foodsby/favorite/ADD_FAVORITE_SUCCESS'
export const ADD_FAVORITE_FAILURE = 'foodsby/favorite/ADD_FAVORITE_FAILURE'

export const LOAD_FAVORITE = 'foodsby/favorite/LOAD_FAVORITE'
export const LOAD_FAVORITE_SUCCESS = 'foodsby/favorite/LOAD_FAVORITE_SUCCESS'
export const LOAD_FAVORITE_FAILURE = 'foodsby/favorite/LOAD_FAVORITE_FAILURE'

export const LOAD_AVAILABLE_FAVORITES =
  'foodsby/favorite/LOAD_AVAILABLE_FAVORITES'
export const LOAD_AVAILABLE_FAVORITES_SUCCESS =
  'foodsby/favorite/LOAD_AVAILABLE_FAVORITES_SUCCESS'
export const LOAD_AVAILABLE_FAVORITES_FAILURE =
  'foodsby/favorite/LOAD_AVAILABLE_FAVORITES_FAILURE'

export const LOAD_HASHES = 'foodsby/favorite/LOAD_HASHES'
export const LOAD_HASHES_SUCCESS = 'foodsby/favorite/LOAD_HASHES_SUCCESS'
export const LOAD_HASHES_FAILURE = 'foodsby/favorite/LOAD_HASHES_FAILURE'

export const DELETE_FAVORITE = 'foodsby/favorite/DELETE_FAVORITE'
export const DELETE_FAVORITE_SUCCESS =
  'foodsby/favorite/DELETE_FAVORITE_SUCCESS'
export const DELETE_FAVORITE_FAILURE =
  'foodsby/favorite/DELETE_FAVORITE_FAILURE'

export const FAVORITE_COMMENT = 'foodsby/favorite/FAVORITE_COMMENT'
export const FAVORITE_COMMENT_SUCCESS =
  'foodsby/favorite/FAVORITE_COMMENT_SUCCESS'
export const FAVORITE_COMMENT_FAILURE =
  'foodsby/favorite/FAVORITE_COMMENT_FAILURE'
export const GET_FAVORITE_COMMENTS = 'foodsby/favorite/GET_FAVORITE_COMMENTS'

export const GET_FAVORITE_COMMENTS_SUCCESS =
  'foodsby/favorite/GET_FAVORITE_COMMENTS_SUCCESS'
export const GET_FAVORITE_COMMENTS_FAILURE =
  'foodsby/favorite/GET_FAVORITE_COMMENTS_FAILURE'

export const LOAD_POPULAR_ITEMS = 'foodsby/favorite/LOAD_POPULAR_ITEMS'
export const LOAD_POPULAR_ITEMS_SUCCESS =
  'foodsby/favorite/LOAD_POPULAR_ITEMS_SUCCESS'
export const LOAD_POPULAR_ITEMS_FAILURE =
  'foodsby/favorite/LOAD_POPULAR_ITEMS_FAILURE'

export const addFavoriteStart = (menuItemId, menuId) => {
  return {
    type: ADD_FAVORITE,
    payload: { menuItemId, menuId }
  }
}

export const addFavoriteSuccess = favorite => {
  return {
    type: ADD_FAVORITE_SUCCESS,
    payload: { favorite }
  }
}

export const addFavoriteFailure = error => {
  return {
    type: ADD_FAVORITE_FAILURE,
    error
  }
}

export const loadFavoriteStart = menuId => {
  return {
    type: LOAD_FAVORITE,
    payload: { menuId }
  }
}

export const loadFavoriteSuccess = favorite => {
  return {
    type: LOAD_FAVORITE_SUCCESS,
    payload: favorite
  }
}

export const loadFavoriteFailure = error => {
  return {
    type: LOAD_FAVORITE_FAILURE,
    error
  }
}

export const loadAvailableFavoritesStart = menuId => {
  return {
    type: LOAD_AVAILABLE_FAVORITES,
    payload: { menuId }
  }
}

export const loadAvailableFavoriteSuccess = availableFavorites => {
  return {
    type: LOAD_AVAILABLE_FAVORITES_SUCCESS,
    payload: availableFavorites
  }
}

export const loadAvailableFavoriteFailure = error => {
  return {
    type: LOAD_AVAILABLE_FAVORITES_FAILURE,
    error
  }
}

export const loadHashesStart = menuItemId => {
  return {
    type: LOAD_HASHES,
    payload: { menuItemId }
  }
}

export const loadHashesSuccess = hashes => {
  return {
    type: LOAD_HASHES_SUCCESS,
    hashes
  }
}

export const loadHashesFailure = error => {
  return {
    type: LOAD_HASHES_FAILURE,
    error
  }
}

export const deleteFavoriteStart = menuItemId => {
  return {
    type: DELETE_FAVORITE,
    payload: { menuItemId }
  }
}

export const deleteFavoriteSuccess = menuItemId => {
  return {
    type: DELETE_FAVORITE_SUCCESS,
    payload: { menuItemId }
  }
}

export const deleteFavoriteFailure = error => {
  return {
    type: DELETE_FAVORITE_FAILURE,
    error
  }
}

export const favoriteCommentStart = (hash, comment) => {
  return {
    type: FAVORITE_COMMENT,
    payload: { hash, comment }
  }
}

export const favoriteCommentSuccess = () => {
  return {
    type: FAVORITE_COMMENT_SUCCESS
  }
}

export const favoriteCommentFailure = error => {
  return {
    type: FAVORITE_COMMENT_FAILURE,
    error
  }
}

export const getFavoriteCommentsStart = (menuId, menuItemId) => {
  return {
    type: GET_FAVORITE_COMMENTS,
    payload: { menuId, menuItemId }
  }
}

export const getFavoriteCommentsSuccess = comments => {
  return {
    type: GET_FAVORITE_COMMENTS_SUCCESS,
    payload: { comments }
  }
}

export const getFavoriteCommentsFailure = error => {
  return {
    type: GET_FAVORITE_COMMENTS_FAILURE,
    error
  }
}

export const loadPopularItems = () => ({
  type: LOAD_POPULAR_ITEMS
})

export const loadPopularItemsSuccess = response => ({
  type: LOAD_POPULAR_ITEMS_SUCCESS,
  payload: { response }
})

export const loadPopularItemsFailure = error => ({
  type: LOAD_AVAILABLE_FAVORITES_FAILURE,
  error
})

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [ADD_FAVORITE]: (state, action) => {
    return {
      ...state,
      isAddingFavorite: true
    }
  },
  [ADD_FAVORITE_SUCCESS]: (state, action) => {
    const { favorite } = action.payload
    const { favorites } = state
    return {
      ...state,
      favorites: [...favorites, favorite],
      isAddingFavorite: false,
      newFavorites: action.payload.favorites
    }
  },
  [ADD_FAVORITE_FAILURE]: (state, action) => {
    const { error } = action
    return {
      ...state,
      isAddingFavorite: false,
      error
    }
  },
  [LOAD_FAVORITE]: (state, action) => {
    return {
      ...state,
      isLoadingFavorites: true
    }
  },
  [LOAD_FAVORITE_SUCCESS]: (state, action) => {
    let favorites = action.payload
    return {
      ...state,
      isLoadingFavorites: false,
      favorites
    }
  },
  [LOAD_FAVORITE_FAILURE]: (state, action) => {
    const { error } = action
    return {
      ...state,
      isLoadingFavorites: false,
      error
    }
  },
  [LOAD_AVAILABLE_FAVORITES]: (state, action) => {
    return {
      ...state,
      isLoadingAvailableFavorites: true
    }
  },
  [LOAD_AVAILABLE_FAVORITES_SUCCESS]: (state, action) => {
    let availableFavorites = action.payload
    return {
      ...state,
      isLoadingAvailableFavorites: false,
      availableFavorites
    }
  },
  [LOAD_AVAILABLE_FAVORITES_FAILURE]: (state, action) => {
    const { error } = action
    return {
      ...state,
      isLoadingAvailableFavorites: false,
      error
    }
  },
  [LOAD_HASHES]: state => {
    return {
      ...state,
      isLoadingHashes: true
    }
  },
  [LOAD_HASHES_SUCCESS]: (state, action) => {
    const hashes = action.hashes
    return {
      ...state,
      isLoadingHashes: false,
      hashes
    }
  },
  [LOAD_HASHES_FAILURE]: (state, action) => {
    const error = action
    return {
      ...state,
      isLoadingHashes: false,
      error
    }
  },
  [DELETE_FAVORITE]: (state, action) => {
    return {
      ...state,
      isDeletingFavorite: true
    }
  },
  [DELETE_FAVORITE_SUCCESS]: (state, action) => {
    const { menuItemId } = action.payload
    const { favorites } = state

    return {
      ...state,
      favorites: favorites.filter(f => f.menuItemId !== menuItemId),
      isDeletingFavorite: false
    }
  },
  [DELETE_FAVORITE_FAILURE]: (state, action) => {
    const { error } = action
    return {
      ...state,
      isDeletingFavorite: false,
      error
    }
  },
  [FAVORITE_COMMENT]: state => {
    return {
      ...state,
      isAddingComment: true
    }
  },
  [FAVORITE_COMMENT_SUCCESS]: (state, action) => {
    return {
      ...state,
      isAddingComment: false
    }
  },
  [FAVORITE_COMMENT_FAILURE]: (state, action) => {
    const error = action.error
    return {
      ...state,
      isAddingComment: false,
      favoriteCommentError: error
    }
  },
  [GET_FAVORITE_COMMENTS]: state => {
    return {
      ...state,
      isLoadingComments: true
    }
  },
  [GET_FAVORITE_COMMENTS_SUCCESS]: (state, action) => {
    const favoriteComments = action.payload.comments
    return {
      ...state,
      favoriteComments,
      isLoadingComments: false
    }
  },
  [GET_FAVORITE_COMMENTS_FAILURE]: (state, action) => {
    const error = action.error
    return {
      ...state,
      isLoadingComments: false,
      loadingCommentsError: error
    }
  },
  [LOAD_POPULAR_ITEMS]: state => ({
    ...state,
    isLoadingPopularItems: true,
    popularItemsError: undefined
  }),
  [LOAD_POPULAR_ITEMS_SUCCESS]: (state, action) => ({
    ...state,
    isLoadingPopularItems: false,
    popularMenuItems: action.payload.response,
    popularItemsError: undefined
  }),
  [LOAD_POPULAR_ITEMS_FAILURE]: (state, action) => ({
    ...state,
    popularItemsError: action.error,
    isLoadingPopularItems: false
  })
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { favorites: [] }

export default function favorite(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

// ------------------------------------
// Sagas
// ------------------------------------

export function* watchAddFavorite() {
  while (true) {
    try {
      const {
        payload: { menuItemId, menuId }
      } = yield take(ADD_FAVORITE)
      let menu
      if (!menuId) {
        menu = yield select(selectCurrentMenu)
      }
      const user = yield select(selectCurrentUser)
      const payloadInfo = {
        menuId: menuId || menu.menuId,
        menuItemId: menuItemId,
        userId: user.userId
      }
      yield call(
        apiSaga,
        addFavorite,
        [payloadInfo],
        addFavoriteSuccess,
        addFavoriteFailure
      )
    } catch (error) {
      yield put(addFavoriteFailure(error))
    }
  }
}

export function* watchMenuItemsAvailableToFavorite() {
  while (true) {
    yield all([take(LOAD_MENU_SUCCESS), take(LOAD_AVAILABLE_FAVORITES)])

    const { menuId } = yield select(selectCurrentMenu)

    yield call(
      apiSaga,
      menuItemsOrdered,
      [menuId],
      loadAvailableFavoriteSuccess,
      loadAvailableFavoriteFailure
    )
  }
}

export function* watchLoadMenuItemHashes() {
  while (true) {
    const {
      payload: { menuItemId }
    } = yield take(LOAD_HASHES)
    yield call(
      apiSaga,
      loadHashedOrders,
      [menuItemId],
      loadHashesSuccess,
      loadHashesFailure
    )
  }
}

export function* watchLoadFavorites() {
  while (true) {
    try {
      let menuId
      const { payload } = yield take(LOAD_FAVORITE)
      menuId = payload.menuId
      if (!menuId) {
        yield race([take(LOAD_MENU_SUCCESS), take(LOAD_MENU_FAILURE)])
        const menu = yield select(selectCurrentMenu)
        menuId = menu.menuId
      }

      const user = yield select(selectCurrentUser)
      if (menuId && user) {
        yield call(
          apiSaga,
          loadFavoritesForMenu,
          [menuId, user.userId],
          loadFavoriteSuccess,
          loadFavoriteFailure
        )
      } else {
        yield put(loadFavoriteFailure())
      }
    } catch (error) {
      yield put(loadFavoriteFailure(error))
    }
  }
}

export function* watchDeleteFavorite() {
  while (true) {
    const {
      payload: { menuItemId }
    } = yield take(DELETE_FAVORITE)
    yield call(
      apiSaga,
      deleteFavorite,
      [menuItemId],
      deleteFavoriteSuccess,
      deleteFavoriteFailure
    )
  }
}

export function* watchAddOrUpdateComments() {
  while (true) {
    const {
      payload: { hash, comment }
    } = yield take(FAVORITE_COMMENT)
    const commentPayload = {
      menuId: hash.menuId,
      menuItemId: hash.menuItemId,
      configurationHash: hash.hash,
      comments: comment
    }
    yield call(
      apiSaga,
      favoriteCommentUpdate,
      [commentPayload],
      favoriteCommentSuccess,
      favoriteCommentFailure
    )
    yield put(getFavoriteCommentsStart(hash.menuId, hash.menuItemId))
  }
}

export function* watchLoadFavoriteComments() {
  while (true) {
    let {
      payload: { menuId, menuItemId }
    } = yield take(GET_FAVORITE_COMMENTS)
    if (!menuId) {
      const menu = yield select(selectCurrentMenu)
      menuId = menu.menuId
    }
    yield call(
      apiSaga,
      getFavoriteComments,
      [menuId, menuItemId],
      getFavoriteCommentsSuccess,
      getFavoriteCommentsFailure
    )
  }
}

export function* watchLoadPopularMenuItems() {
  while (true) {
    try {
      yield all([
        take(LOAD_POPULAR_ITEMS),
        race([take(LOAD_MENU_SUCCESS), take(LOAD_MENU_FAILURE)])
      ])

      const menu = yield select(selectCurrentMenu)
      yield call(
        apiSaga,
        loadPopularMenuItems,
        [menu.menuId],
        loadPopularItemsSuccess,
        loadPopularItemsFailure
      )
    } catch (ex) {
      yield put(loadPopularItemsFailure(ex))
    }
  }
}

export const menuItemsOrdered = menuId =>
  callApi.get(`/api-monolith/menu/${menuId}/items`)

export const addFavorite = payloadInfo =>
  callApi.post(`/api/v2/favorites`, payloadInfo)

export const loadFavoritesForMenu = menuId =>
  callApi.get(`/api/v2/favorites?menu=${menuId}`)

export const deleteFavorite = menuItemId =>
  callApi
    .delete(`/api/v2/favorites/${menuItemId}`)
    .then(response => ({ ...response, data: menuItemId }))

export const loadHashedOrders = menuItemId =>
  callApi.get(`/api-monolith/menu/item/${menuItemId}/configurations`)

export const favoriteCommentUpdate = commentPayload =>
  callApi.put(`/api/v2/favorites/comments`, commentPayload)

export const getFavoriteComments = (menuId, menuItemId) =>
  callApi.get(
    `/api/v2/favorites/comments?menu=${menuId}&menuItem=${menuItemId}`
  )

export const loadPopularMenuItems = menuId =>
  callApi.get(`/api/v1/connections/friends-favorites/popular?menuId=${menuId}`)
